// @flow
import React from 'react';
import {ExpandMoreRounded, ExpandLessRounded} from '@material-ui/icons';
import {Collapse, Typography, Divider, ButtonBase} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import {colors} from '../../assets/styles/colors';
import {classNames, useToggle} from '../../utils/react';

type Props = {
  children: React$Node,
  startIcon?: React$Node,
  title: React$Node | string,
  startOpen?: boolean,
  className?: string,
  divisible?: boolean,
};

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
  },
  title: {
    color: colors.grey900,
    fontWeight: 600,
    flexGrow: 1,
  },
  button: {
    width: '100%',
    justifyContent: 'space-between',
    textTransform: 'none',
    fontWeight: 500,
    fontSize: 14,
    textAlign: 'left',
    padding: '.75rem .5rem',
    borderRadius: '.5rem',
    gap: '.5rem',
  },
  childrenArea: {
    paddingTop: 0,
  },
  content: {
    cursor: 'default',
    padding: '0 .5rem',
  },
  divider: {
    background: colors.grey300,
  },
}));

export default function TiendadaCollapse(props: Props) {
  const {children, startIcon, title, startOpen, className, divisible} = props;
  const classes = useStyles();

  const [open, toggleOpen] = useToggle(!!startOpen);

  return (
    <div className={classNames(classes.root, className)}>
      <ButtonBase className={classes.button} fullWidth onClick={toggleOpen}>
        {startIcon && <span className={classes.icon}>{startIcon}</span>}
        <Typography className={classes.title}>{title}</Typography>
        {open ? <ExpandLessRounded /> : <ExpandMoreRounded />}
      </ButtonBase>
      <Collapse in={open}>
        <div className={classes.childrenArea}>
          {divisible && <Divider className={classes.divider} />}
          <div className={classes.content} onClick={e => e.stopPropagation()}>
            {children}
          </div>
        </div>
      </Collapse>
    </div>
  );
}
